import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  panel: {
    padding: '0 10px',
    minWidth: '526px',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingTop: '25px',
    paddingBottom: '25px',
    justifyContent: 'center',
    position: 'relative',
  },
  unitName: {
    fontSize: '28px',
    fontWeight: 400,
    lineHeight: '32.81px',
    color: '#ffffff',
    textAlign: 'center',
  },
  scheduleButtonWrapper: {
    position: 'absolute',
    right: 16,
    display: 'flex',
    alignItems: 'center',
  },
  scheduleButton: {
    color: '#9b8b9b',
    width: '40px',
    height: '40px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  badge: {
    position: 'absolute',
    top: '-4px',
    right: '-2px',
    padding: '3px 7px',
    fontSize: '12px',
    lineHeight: 'normal',
    borderRadius: '10px',
    background: theme.palette.colors.white,
    color: theme.palette.primary.main,
  },
  body: {
    position: 'relative',
    borderRadius: '8px',
    minHeight: '400px',
    overflow: 'hidden',
  },
  // Scales the fixed-size 486x495 canvas (ModbusUIRenderer.module.css) to fit
  // .body's actual width - mirrors BACnet's scalableMappingArea technique.
  canvasScaler: {
    position: 'absolute',
    top: 0,
    left: 0,
    transformOrigin: 'top left',
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    color: '#888',
  },
}));
